import { styled } from '@mui/system'
import { TTheme } from '@/core/theme'
import { StyledCustomTable } from '@/ui/components/CustomTable/CustomTable.styles'
import { drawerScrollFade } from '@/ui/drawer/common/drawerTable.styles'

export const TableSection = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
`

export const SearchWrapper = styled('div')`
    max-width: 320px;
`

export const AssetsTable = styled(StyledCustomTable)<{ theme?: TTheme }>`
    width: 100%;
    border-radius: 12px;
    border: 1px solid ${({ theme }) => theme.colors.semantic.tableBorder};
    overflow: hidden;

    table {
        th:first-of-type {
            border-top-left-radius: 12px;
            padding-left: 24px;
        }

        th:last-of-type {
            border-top-right-radius: 12px;
        }

        th {
            height: 44px;
            padding-top: 6px;
            padding-bottom: 6px;
        }

        td {
            padding-top: 14px;
            padding-bottom: 14px;
            vertical-align: middle;
            color: ${({ theme }) => theme.colors.greys[800]};
        }

        td:first-of-type {
            padding-left: 24px;
        }

        th:nth-of-type(2),
        td:nth-of-type(2) {
            padding-left: 40px;
        }

        th:nth-of-type(2):last-of-type,
        td:nth-of-type(2):last-of-type {
            width: auto !important;
        }

        td:last-of-type {
            padding-right: 12px;
        }
    }

    ${drawerScrollFade}
`
